import ActionCable from "actioncable";

// Authenticated cable consumer for the inquiry pipeline (InquiriesChannel):
// new consultas, thread messages, funnel moves. Same token-as-query-param auth
// as chatCable. One shared consumer/socket regardless of how many components
// subscribe (bell, sidebar badge, list, board, an open thread).
let consumer = null;

function wsUrl() {
  const base = process.env.VUE_APP_WS_URL || "ws://localhost:3010/cable";
  const token = sessionStorage.getItem("access_token") || "";
  if (!token) return base;
  const sep = base.includes("?") ? "&" : "?";
  return `${base}${sep}token=${encodeURIComponent(token)}`;
}

// `onData(payload)` fires on every inquiry event: inquiryCreated | inquiryUpdated
// | inquiryDeleted | comment | state | nextAction (all carry inquiryId).
// Returns the subscription (call .unsubscribe()).
export function subscribeInquiries(onData) {
  if (!consumer) consumer = ActionCable.createConsumer(wsUrl());
  return consumer.subscriptions.create(
    { channel: "InquiriesChannel" },
    { received(data) { try { onData(data); } catch (e) { /* ignore */ } } }
  );
}
